import * as React from "react";

function SvgToggleOn(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 23.95 14.94"
      focusable={false}
      role="presentation"
      aria-hidden={true}
      {...props}
    >
      <path d="M16.49-.02h-9A7.46 7.46 0 00.01 7.47a7.47 7.47 0 007.46 7.51h9a7.47 7.47 0 007.46-7.47 7.46 7.46 0 00-7.44-7.53zm0 13.55a6 6 0 116-6.05 6 6 0 01-6 6.07z" />
    </svg>
  );
}

const MemoSvgToggleOn = React.memo(SvgToggleOn);
export default MemoSvgToggleOn;
